import { Fragment, h } from 'preact'
import { useState } from 'preact/hooks'
import { connect } from 'unistore/preact'
import { BasicDialog, Form, NativeSelect, Select, SpacerVertical, TextField } from '@sodra/bongo-ui'
import { goBack } from '@sodra/prutt'

import { createColor } from '../../../actions/colors.js'
import { ColorInput } from './ColorInput.js'

const CreateColor = ({ project, isUpdatingProject }) => {
  let [attributeId, setAttributeId] = useState('')
  let [operand, setOperand] = useState('')
  let [value, setValue] = useState('')
  let [color, setColor] = useState('#000000')

  let attribute = attributeId && project.attributes.find((a) => a.id === attributeId)

  const handleSubmit = async () => {
    if (!attributeId) {
      return
    }
    if (attribute.type === 'boolean') {
      value = 'checked'
    }
    if (await createColor({ attributeId, operand, value, color })) {
      onClose()
    }
  }

  const onClose = () => goBack(`/projects/${project.id}/colors`)

  let attributeOptions = []
  for (let attribute of project.attributes) {
    if (attribute.type !== 'date') {
      attributeOptions.push({ value: attribute.id, label: attribute.name })
    }
  }

  let operandOptions = []
  if (attribute) {
    if (attribute.type === 'text') {
      operandOptions = [
        { value: 'eq', label: 'Lika med' },
        { value: 'not', label: 'Inte lika med' },
        { value: 'contains', label: 'Innehåller' },
        { value: 'not_contains', label: 'Inte innehåller' }
      ]
    } else if (attribute.type === 'number') {
      operandOptions = [
        { value: 'eq', label: '=' },
        { value: 'lt', label: '<' },
        { value: 'lte', label: '<=' },
        { value: 'gt', label: '>' },
        { value: 'gte', label: '>=' },
        { value: 'not', label: '<>' }
      ]
    } else if (attribute.type === 'boolean') {
      operandOptions = [
        { value: 'eq', label: 'Markerad' },
        { value: 'not', label: 'Inte markerad' }
      ]
    }
  }

  return (
    <BasicDialog
      disableAutofocus
      title="Ny färg"
      primaryActionText="Spara"
      primaryActionLoading={isUpdatingProject}
      onPrimaryActionClick={handleSubmit}
      action1Text="Avbryt"
      onAction1Click={onClose}
      onClose={onClose}
    >
      <Form onSubmit={handleSubmit}>
        <NativeSelect
          width="100%"
          label="Attribut"
          value={attributeId}
          onChange={setAttributeId}
          options={attributeOptions}
        />
        <SpacerVertical />
        <NativeSelect
          width="100%"
          label="Jämförelse"
          value={operand}
          onChange={setOperand}
          options={operandOptions}
          disabled={operandOptions.length === 0}
        />
        {(!attribute || attribute.type !== 'boolean') && (
          <Fragment>
            <SpacerVertical />
            <TextField
              width="100%"
              label="Värde"
              autocomplete="off"
              value={value}
              onInput={setValue}
            />
          </Fragment>
        )}
        <SpacerVertical />
        <ColorInput label="Färg" value={color} onChange={setColor} />
      </Form>
      <SpacerVertical />
    </BasicDialog>
  )
}

export default connect('project, isUpdatingProject')(CreateColor)
